import DeviceElevatorIntegrationMainSettings from './DeviceElevatorIntegrationMainSettings';

export default DeviceElevatorIntegrationMainSettings;
